var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoPlayer",staticClass:"video-js w-100",attrs:{"id":"videoPlayer","data-setup":"{ \"audioOnlyMode\": true, \"playbackRates\": [0.75, 1, 1.25] }"}})
}
var staticRenderFns = []

export { render, staticRenderFns }